/** @format */

import { ApplicationRef, enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication, enableDebugTools } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { chain } from '@core/chain';
import { environment, prepareApp } from './environments/environment';
import { startHoneycomb } from '@shared/ssr-core/data-access';

if (environment.production) {
  enableProdMode();
}

// Is Honeycomb enabled for the current chain?
if (environment.killSwitch.honeycombEnabled[chain.chainIdentifierAbbr]) {
  startHoneycomb(
    environment.thirdParty.honeycomb.apiKey,
    environment.thirdParty.honeycomb.serviceName,
    'plp',
    chain.chainIdentifierAbbr,
  );
}

document.addEventListener('DOMContentLoaded', async () => {
  await prepareApp();

  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...appConfig.providers],
  })
    .then((app) => {
      if (!environment.production) {
        const applicationRef = app.injector.get(ApplicationRef);
        const appComponent = applicationRef.components[0];
        enableDebugTools(appComponent);
      }
    })
    .catch((error) =>
      // tried to use logger.error but seems to break the webpage.
      // eslint-disable-next-line no-console
      console.error(
        `APPLICATION_ERROR:BOOTSTRAP_ERROR: ${JSON.stringify(error, ['message', 'arguments', 'type', 'name'])}`,
      ),
    );
});
